import composer from '@/composers';

export const component = (
  storeName: string,
  store: any,
  view: IView,
) => composer({
  mergeFunction: {
    created: {
      where: 'before',
      cb(this: any) {
        this.$storeRegister(storeName, store);
      },
    },
    beforeDestroy: {
      where: 'after',
      cb(this: any) {
        this.$storeUnregister(storeName);
      },
    },
  },
}, view);
